/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useState, useEffect } from 'react';
import Tenantsdashboard from '../../modules/custom/accounts/Tenants/Tenants';
import { useAuth } from '../../modules/auth';
import { Spinner } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';

const Tenants: React.FC = () => {
    const { currentUser } = useAuth();
    const [loading, setLoading] = useState(true);
    const navigate = useNavigate();

    //   Validación de permisos y redirección
    useEffect(() => {
        const delay = setTimeout(() => {
            setLoading(false);
            if (!currentUser?.ListPermiso?.includes('Tenant.list')) {
                // Si no tiene permisos para SSO.List, redirigir a otra ruta
                navigate('/dashboard');
            }
        }, 1000);

        // Limpiar timeout si el componente se desmonta
        return () => clearTimeout(delay);
    }, [currentUser, navigate]);

    // Mostrar spinner mientras se cargan los permisos
    if (loading) {
        return (
            <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh', flexDirection: 'column' }}>
                <Spinner animation="border" role="status" variant="primary">
                    <span className="visually-hidden">Loading...</span>
                </Spinner>
                <div className="text-marino" style={{ marginTop: '20px', fontSize: '18px', color: '#007bff' }}>
                    We are validating your permissions...
                </div>
            </div>
        );
    }

    return (
        <div className='card mb-5 mb-xl-5'>
            <Tenantsdashboard />
        </div>
    );
}

export { Tenants };